import { render } from "./CategorySelect.vue?vue&type=template&id=08bca548&scoped=true"
import script from "./CategorySelect.vue?vue&type=script&lang=js"
export * from "./CategorySelect.vue?vue&type=script&lang=js"

import "./CategorySelect.vue?vue&type=style&index=0&id=08bca548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bca548"]])

export default __exports__